import { render, staticRenderFns } from "./FooterSubscribe.vue?vue&type=template&id=03528dd9"
import script from "./FooterSubscribe.vue?vue&type=script&lang=js"
export * from "./FooterSubscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScNewsletterForm: require('/opt/build/repo/node_modules/@evince/site/lib/packages/NewsletterForm.vue').default})
